export default __webpack_public_path__ + "static/media/Globe.a1172cd2.png";